const BASE_URL = `${window.location.protocol}//${window.location.host}`;
const BASE_URL1 = `${window.location.origin}`;

export async function getX3Folders() {
    const res = await fetch(`${BASE_URL}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
    });
    

    const text = await res.text();
    let data = null;

    try {
        data = text ? JSON.parse(text) : null;
    } catch (err) {
        data = null;
    }

    // Throw only for unexpected statuses (500 etc)
    if (res.status >= 500) {
        throw new Error(data?.error || `Server error (${res.status})`);
    }

    const rawFolders = Array.isArray(data)
    ? data
    : (data?.folders ?? []);

    // ensuring no blank folders are returned.
    const filteredFolders = (rawFolders || []).map(item => item.DOSSIER)
    .filter(f => typeof f === 'string')
    .map(f => f.trim())
    .filter(f => f !== ''); 

    return { status: res.status, ok: res.ok, data: filteredFolders };
}


export async function testX3Connection(sageConfig) {
    const res = await fetch(`${BASE_URL}/api/sageX3/test_connection`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(sageConfig)
    });

    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        data = null;
    }

    if (res.status >= 500) {
        throw new Error(data?.error || `Server error (${res.status})`);
    }
    return { status: res.status, ok: res.ok, data };
}


export async function getX3Users(folderName) {
    const res = await fetch(`${BASE_URL1}/api/sageX3/get_x3_users?folder=` + folderName, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        data = null;
    }

    // Throw only for unexpected statuses (500 etc)
    if (res.status >= 500) {
        throw new Error(data?.error || `Server error (${res.status})`);
    }
    return { status: res.status, ok: res.ok, users: data.users };
}